import React from 'react';

import Dialog from 'material-ui/Dialog';
import './alert.css';

const FooterDialogApple = ({ closeDialog, isDialogOpen }) => (
  <Dialog
    actions={
      <div className="plus-buttons-div">
        <button type="button" className="alert-button" onClick={closeDialog}>
          CLOSE
        </button>
      </div>
    }
    open={isDialogOpen}
    paperProps={{ style: { borderRadius: '4px' } }}>
    <p style={{ textAlign: 'center', marginTop: '20px' }}>Our Apple app is coming soon! Stay tuned!</p>
  </Dialog>
);

export default FooterDialogApple;



// WEBPACK FOOTER //
// ./src/components/Alert/FooterDialogApple.js